<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formArticleSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="w_docarticlesearch.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListDocumentArticles"></tt-list>
</tt-page>
